import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd]   = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const { login }  = useAuth();
  const navigate   = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch {
      setError('Invalid email or password. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/TycheAbodes-logo1.png" alt="Tyche Abodes" style={{width:60, height:60, objectFit:'contain', borderRadius:8}} onError={e=>e.target.style.display='none'}/>
          <div className="text">
            <h1>Tyche Abodes</h1>
            <p>Granite ERP — Quarry Management System</p>
          </div>
        </div>

        <p style={{ fontSize:13, color:'var(--text-secondary)', marginBottom:24 }}>
          Sign in to access your dashboard
        </p>

        {error && <div className="error-box">{error}</div>}

        <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input type="email" className="form-input" placeholder="admin@granite.com"
              value={email} onChange={e => setEmail(e.target.value)} required/>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position:'relative' }}>
              <input type={showPwd ? 'text' : 'password'} className="form-input"
                placeholder="Enter your password"
                value={password} onChange={e => setPassword(e.target.value)}
                style={{ paddingRight:44 }} required/>
              <button type="button" onClick={() => setShowPwd(!showPwd)} style={{
                position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
                background:'none', border:'none', color:'var(--text-muted)',
                cursor:'pointer', fontSize:12, fontWeight:600,
              }}>
                {showPwd ? 'Hide' : 'Show'}
              </button>
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-lg"
            disabled={loading} style={{ width:'100%', justifyContent:'center', marginTop:8 }}>
            {loading
              ? <><div className="spinner" style={{ width:15, height:15 }}/> Signing in...</>
              : 'Sign In'
            }
          </button>
        </form>

        <div style={{ textAlign:'center', marginTop:24, paddingTop:20, borderTop:'1px solid var(--border)' }}>
          <p style={{ fontSize:11, color:'var(--text-muted)' }}>
            Granite Quarry ERP v1.0 &nbsp;·&nbsp; Secure Access
          </p>
        </div>
      </div>
    </div>
  );
}
